// extracted by mini-css-extract-plugin
export default {"content":"CloneStep_content__SO+hg"};